<template>
    <div class="homepage__word-map">
        <h4 class="title">Start practicing 1000 math skills immediately</h4>
        <img src="/images/lp/lp-word-map.svg" alt="word-map" class="img" />
    </div>
</template>
<style lang="scss" scoped>
.homepage__word-map {
    background: #572598;
    padding: 3rem 0 2rem;

    @include mq($w-max-phone, max) {
        padding: 2rem 0;
    }

    .title {
        font-weight: 700;
        font-size: 32px;
        line-height: 39px;
        text-align: center;
        color: #ffffff;

        @include mq($w-max-phone, max) {
            font-size: 24px;
            line-height: 29px;
        }
    }

    .img {
        display: block;
        margin: auto;
        max-width: 100%;
        height: auto;
    }
}
</style>
